import { async } from "@firebase/util";
import { getDatabase, ref, child, get, update} from "firebase/database";
import { IpAddresses } from "../Constants/constants";

export const get_event = async (uid, id) => {
    const dbRef = ref(getDatabase());
    const post = await get(child(dbRef, `Events/${uid}/${id}/data/`)).then((snapshot) => {
        if (snapshot.exists()) {
          return snapshot.val();
        } else {
            console.log("No data available");
            return({})          
        }
      }).catch((error) => {        
        console.error(error);
        return([])          
      });
    return(post)            
}

export const get_event_title = async (uid, id) => {
    const dbRef = ref(getDatabase());
    const title = await get(child(dbRef, `Events/${uid}/${id}/data/title`)).then((snapshot) => {
        if (snapshot.exists()) {
          return snapshot.val();
        } else {
            console.log("No data available");
            return([])          
        }
      }).catch((error) => {        
        console.error(error);
        return([])          
      });
    return(title)            
}

export const getUserFirebase = async (uid) =>{
    let URL = IpAddresses.flaskUrl+"/get_current_user"
 
    let options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',            
        },
        body: JSON.stringify({
            uid: uid
        })
    }
    try{
        let response = await fetch(URL, options)
        let json = await response.json()
        return json
    }catch(err){
        if(err.message == "Network request failed"){
            return {
                "errorMessage": "Network Error: Check your internet connection"
            }
        }else{
            //console.log("Error" + err)
            return{
                "errorMessage": "Error"
            }
        }        
    }
}

export const getAllUsers = async() => {
    const dbRef = ref(getDatabase());
    const post = await get(child(dbRef, `Users/`)).then((snapshot) => {
        if (snapshot.exists()) {
          return snapshot.val();
        } else {
            console.log("No data available");
            return([])          
        }
      }).catch((error) => {        
        console.error(error);
        return([])          
      });
    return(post)   
}

export const accept_invite = async(input) => {      
    try{
        const dbRef = ref(getDatabase());  
        let invObj = {}
        invObj[input['uid']] = input.status   
        console.log(invObj)
        const resp = await update(child(dbRef, `Events/${input.author}/${input.id}/data/invites`), invObj)    
        const updateUser = await update(child(dbRef, `Events/${input['uid']}/${input.id}/data/`), input.post)
        return(resp)
    }catch(err){
        console.log(err)
        alert("Something went wrong, please try again later!")
    }
}

export const getEventStatus = async(input) => {
    const dbRef = ref(getDatabase());
    const inviteStatus = await get(child(dbRef, `Events/${input.author}/${input.id}/data/invites`)).then((snapshot) => {
        if (snapshot.exists()) {    
            return snapshot.val();
        } else {
            console.log("No data available");
            return([])          
        }
      }).catch((error) => {        
        console.log(error);
        return([])          
      });    
    return(inviteStatus)
}

export const updateUserDetails = async(input, uid) => {
    const dbRef = ref(getDatabase());
    const resp = await update(child(dbRef, `Users/${uid}/`), input).then((snapshot) => {
        
    })
  
    return(resp)
}

export const declineInvitation = async (input) => {
    const dbRef = ref(getDatabase());  
    let invObj = {}
    invObj[input['uid']] = input.status   
    const resp = await update(child(dbRef, `Events/${input.author}/${input.id}/data/invites`), invObj)
   
    return(resp)
}

// export const accept_invite_guest = async (input) =>{
//     let URL = IpAddresses.flaskUrl+"/accept_guest_invite"
//     let options = {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',            
//         },
//         body: JSON.stringify(input)
//     }
//     try{
//         let response = await fetch(URL, options)
//         let json = await response.json()        
//         return json
//     }catch(err){
//         if(err.message == "Network request failed"){
//             return {
//                 "errorMessage": "Network Error: Check your internet connection"
//             }
//         }else{            
//             return{
//                 "errorMessage": "Error"
//             }
//         }        
//     }
// }

export const addNewUserToFirebase = async(input) => {
    const dbRef = ref(getDatabase());      
    const resp = await update(child(dbRef, `Users/${input.uid}/`), input)    
    return(resp)
}

export const signupFlask = async (input) =>{
    let URL = IpAddresses.flaskUrl+"/create_user_data"    
    let options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(input)
    }
    try{
        let response = await fetch(URL, options)
        let json = await response.json()
        if(response.status == 201) {            
            return json
        } else {
            let errStr = Object.values(json)[0][0]
            return {"error": errStr}
        }
    }catch(err){
        if(err.message == "Network request failed"){
            return {
                "errorMessage": "Network Error: Check your internet connection"
            }
        }else{
            //console.log("Error logging in" + err)
            return{
                "errorMessage": "Error signing up, try again later"
            }
        }        
    }
}

export const request_host_for_waitlist = async(input) => {
    let URL = IpAddresses.flaskUrl+"/send_notification_to_waitlist_host";        
    let options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',            
        },
        body: JSON.stringify(input)
    } 
    await fetch(URL, options).then((resp) => {              
        return(resp.json())
    }) 
}   